import React, { createContext, useState } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        try {
            const storedUser = localStorage.getItem('user');
            if (!storedUser) return null;
            const parsed = JSON.parse(storedUser);
            if (typeof parsed !== 'object' || parsed === null) {
                localStorage.removeItem('user');
                return null;
            }
            return parsed;
        } catch {
            localStorage.removeItem('user');
            return null;
        }
    });

    const login = (token, userData) => {
        const userInfo = {
            token,
            username: userData?.username ?? userData,
            role: userData?.role,
            empresaClienteId: userData?.empresaClienteId ?? null,
            empresaClienteNome: userData?.empresaClienteNome ?? null,
        };
        setUser(userInfo);
        localStorage.setItem('user', JSON.stringify(userInfo));
        localStorage.setItem('token', token);
    };

    const logout = () => {
        setUser(null);
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        localStorage.removeItem('companyName');
        localStorage.removeItem('companyId');
    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
